import { TurboMount } from "turbo-mount"
import sveltePlugin from "turbo-mount/svelte"
import { registerComponents } from "turbo-mount/registerComponents/vite"

import HealthCard from "../components/HealthCard.svelte"
import UsageChart from "../components/UsageChart.svelte"
import PiiEventChart from "../components/PiiEventChart.svelte"
import SuperAdminOrgUsage from "../components/SuperAdminOrgUsage.svelte"

let turboMount

const components = {
  HealthCard,
  UsageChart,
  PiiEventChart,
  SuperAdminOrgUsage,
}

const registerTurboMount = () => {
  if (window.Stimulus?.turboMount) return
  if (!window.Stimulus) return

  turboMount = new TurboMount({ application: window.Stimulus })

  registerComponents({
    plugin: sveltePlugin,
    turboMount,
    components,
  })
}

registerTurboMount()

if (!window.Stimulus?.turboMount) {
  document.addEventListener("DOMContentLoaded", registerTurboMount, { once: true })
}
